import { useEffect, useRef, useState } from "react";
import Icons from "../../assets/icon/index";

const InfoTooltip = ({ label, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleOutsideClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    const handleEscape = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  return (
    <span className="relative inline-flex items-center" ref={wrapperRef}>
      <button
        type="button"
        aria-label={label ? `${label} information` : "More information"}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}
        className="inline-flex items-center justify-center cursor-pointer rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-goldMetallic"
      >
        <img src={Icons.informationIcon} alt="" className="w-4 h-4" />
      </button>

      {isOpen && (
        <span
          role="tooltip"
          className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2.5 w-[min(85vw,20rem)] rounded-lg bg-[#171717] shadow-lg z-20 animate-[fadeIn_0.15s_ease-out]"
        >
          <span className="block max-h-[60vh] overflow-y-auto text-white text-xs font-onestRegular leading-5 px-3.5 py-3 whitespace-normal text-left">
            {content}
          </span>
          <span className="absolute top-full left-1/2 -translate-x-1/2 -mt-[1px] w-3 h-3 bg-[#171717] rotate-45" />
        </span>
      )}
    </span>
  );
};

export default InfoTooltip;
